import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

const trendingResourcesCarousel = document.querySelectorAll(".trending-resources");

trendingResourcesCarousel.forEach((slider, index) => {
    const Carousel = slider.querySelector(".swiper");
    const prevArrow = slider.querySelector(".swiper-button-prev");
    const nextArrow = slider.querySelector(".swiper-button-next");

    new Swiper(Carousel, {
        modules: [Navigation],
        slidesPerView: "auto",
        centerInsufficientSlides: true,
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
        },
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            792: {
                slidesPerView: 3,
            },
        }
    });
});
